// These are conditional imports that will be included in the Autodesk.Viewing namespace, if compiling for the browser

export { default as Hammer } from '../../../../thirdparty/hammer/hammer';